import React from 'react';
import { parseAnalystRating, ratingScaleStyle } from '../utils/ratingScale';

// Yahoo's analyst consensus ("2.0 - Buy": 1 = Strong Buy … 5 = Sell), coloured on
// the shared 1–5 ladder. ONE renderer for the table's Analysts Rating cell and
// the stock profile's snapshot tile (issue #445). A string that isn't in that
// shape is shown as-is rather than dropped.
const AnalystRatingText = ({ rating }) => {
  if (!rating) return null;
  const parsed = parseAnalystRating(rating);
  if (!parsed) return <>{rating}</>;
  return (
    <span style={ratingScaleStyle(parsed.value)}>
      {parsed.value.toFixed(1)} {parsed.label}
    </span>
  );
};

export default AnalystRatingText;
